<template>
	<dialog-slot
			title="Exceptions"
			@updateClose="onDrawerClose"
			@updateSave="onSave"
			apply-text="Add new"
			width="1100px"
			is-full-screen
	>
		<div class="modalExceptionsWrap">
			<v-tabs
					class="tabList"
					v-model="tab"
					center-active
					height="40"
					show-arrows
			>
				<v-tabs-slider />
				<v-tab
						v-for="item in getTabList"
						:key="item.tab"
						:href="item.href"
						class="tab"
						:class="{ errorTab: item.error }"
				>
					<div class="icon mr-2" v-if="item.showIcon">
						<svg-sprite
								:icon-id="item.icon"
								width="20"
								height="20"
						/>
					</div>

					<div class="text">{{ item.text }}</div>
				</v-tab>
			</v-tabs>

			<v-tabs-items v-model="tab">
				<v-tab-item value="tabOpen">
					<open
							ref="openTable"
							:key="'exceptions-open'"
							@updateEdit="onEdit"
					/>
				</v-tab-item>

				<v-tab-item value="tabClose">
					<close
							ref="closeTable"
							:key="'exceptions-close'"
							@updateEdit="onEdit"
					/>
				</v-tab-item>
			</v-tabs-items>
		</div>

	</dialog-slot>
</template>

<script>
import DialogSlot from "@/shared/DialogSlot/DialogSlot.vue";
import Open from "@/pages/Safety/LogbooksList/Exception/Open/Open.vue";
const Close = () => import("@/pages/Safety/LogbooksList/Exception/Close/Close.vue");

export default {
	name: "ExceptionMod",
	components: { DialogSlot, Open, Close },
	data: () => ({
		tab: "tabOpen",
	}),
	computed: {
		getTabList() {
			return [
				{
					text: "Open",
					tab: "tabOpen",
					href: "#tabOpen",
					icon: "warning",
					error: false,
					showIcon: true,
				},
				{
					text: "Close",
					tab: "tabClose",
					href: "#tabClose",
					icon: "done",
					error: false,
					showIcon: true,
				},
			];
		},
	},
	methods: {
		onDrawerClose() {
			this.$emit("updateCloseDialogExceptions");
		},
		onSave() {
			this.$emit("updateAdd");
		},
		onEdit(arg) {
			this.$emit("updateEdit", arg);
		},
		refreshTables() {
			if (this.$refs.openTable) this.$refs.openTable.externalRefresh();
			if (this.$refs.closeTable) this.$refs.closeTable.externalRefresh();
		},
	},
};
</script>

<style lang="scss">
.modalExceptionsWrap {
	.main-table-all-back-wrap {
		font-size: 14px;
		font-weight: 400;
		.pageList--wrap {
			padding: 0;
		}
		.pageContentHeader {
			display: none;
		}
	}
}
</style>
